<div [class.workspace-page]="!inline" [class.workspace-page--full]="!inline" [class.workspace-page__panel--card]="!inline" class="br-compact-page">
  <header *ngIf="!inline" class="workspace-page__heading">
    <div class="br-min-w-0">
      <h1 class="workspace-page__title">{{ isView && profile?.name ? profile?.name : title }}</h1>
      <p *ngIf="isView && profile" class="br-text-muted br-mt-2 br-mb-0">{{ viewSubtitle }}</p>
    </div>
    <div class="workspace-page__title-actions">
      <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm"
              (click)="back()">
        <br-icon>arrow_back</br-icon> {{ backLabel }}
      </button>
    </div>
  </header>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div class="br-form-error lead-page__load-error" *ngIf="error && isView">{{ error }}</div>

  <!-- The whole record, in tabs. The page owns the profile because the Edit
       form needs it, and hands it down rather than printing it here as well:
       it used to render the fields itself and switch the detail component's
       matching sections off, which is why that component's first tab held
       only leftovers and was called Overview. Behind LeadWorkItem.View
       because that is what its read is gated on, and this route also admits
       Lead.View alone. -->
  <div *ngIf="inline && showEditAction && isView && profile && auth.hasPermission('Lead.Manage')" class="lead-page__inline-heading">
    <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" (click)="edit()" [disabled]="loading">
      <br-icon>edit</br-icon> Edit
    </button>
  </div>
  <app-work-item-detail [class.workspace-page__panel]="!inline" [hidden]="!isView" *ngIf="(inline || isView) && profile && auth.hasPermission('LeadWorkItem.View')"
                        [leadId]="leadId"
                        [inline]="inline"
                        [record]="record"
                        [nextAction]="nextAction"
                        [reps]="boardReps"
                        [canManagePipeline]="auth.hasPermission('LeadPipeline.Manage')"
                        [canManageLeads]="auth.hasPermission('Lead.Manage')"
                        [canPlanVisit]="canPlanVisit"
                        (visitRequested)="planVisit()"
                        [canApproveQuotes]="auth.hasPermission('Automation.Approve')"
                        (editRequested)="edit()"
                        (changed)="reloadProfile()">
  </app-work-item-detail>

  <button *ngIf="!inline && isView && profile && !auth.hasPermission('LeadWorkItem.View') && auth.hasPermission('Lead.Manage')"
          type="button" class="br-btn br-btn--outline-secondary br-btn--sm" (click)="edit()">
    <br-icon>edit</br-icon> Edit
  </button>
  <div *ngIf="inline && isView && profile && !auth.hasPermission('LeadWorkItem.View')">
    <section *ngFor="let section of record" class="lead-record__section">
      <h2>{{ section.title }}</h2>
      <dl class="lead-record__rows">
        <ng-container *ngFor="let field of section.rows">
          <dt>{{ field.label }}</dt><dd [class.lead-record__empty]="field.empty">{{ field.value }}
              <app-map-pin *ngIf="field.location as location"
                           [latitude]="location.latitude" [longitude]="location.longitude"
                           [object]="location.object" [popup]="location.popup"></app-map-pin></dd>
        </ng-container>
      </dl>
    </section>
  </div>
  <form [class.workspace-page--full]="!inline" [class.workspace-page__panel]="!inline" (ngSubmit)="save()" *ngIf="!isView || (!inline && profile && !auth.hasPermission('LeadWorkItem.View'))">
    <app-lead-profile-fields [class.workspace-page__body]="!inline" [class.br-px-3]="!inline"
      [form]="form"
      [loading]="loading"
      [stagesLoading]="stagesLoading"
      [repsLoading]="repsLoading"
      [businessTypesLoading]="businessTypesLoading"
      [stages]="stages"
      [reps]="reps"
      [businessTypes]="businessTypes">
    </app-lead-profile-fields>

    <div class="lead-page__actions workspace-page__footer br-justify-end" [class.workspace-page__footer--inline]="inline" *ngIf="!isView">
      <span class="br-form-error" *ngIf="error">{{ error }}</span>
      <button class="br-btn br-btn--outline-secondary" type="button"
              (click)="cancel()" [disabled]="saving">Cancel</button>
      <button class="br-btn br-btn--primary" type="submit"
              [disabled]="loading || saving">
        {{ saving ? 'Saving...' : inline ? 'Save changes' : submitLabel }}
      </button>
    </div>
  </form>
</div>
